import * as Sentry from '@sentry/browser';
import posthog from 'posthog-js';

export const sentryPropagationTargets: RegExp[] = [
    /^https?:\/\/([a-z0-9]+\.)*isiparts\.com/,
    /^https?:\/\/([a-z0-9-]+\.)*isiparts\.pages\.dev/,
    /^https?:\/\/isiparts\.frain\.es/,
];

export const enableAnalytics = (): void => {
    enableSentryAnalytics();
    enablePostHogAnalytics();
};

export const enableSentryAnalytics = (): void => {
    Sentry.init({
        dsn: 'https://0825b8d53e7694ba827b2c18d224c96b@o4508256865812480.ingest.de.sentry.io/4508256869613648',
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: sentryPropagationTargets,
        // Session Replay
        replaysSessionSampleRate: 1.0, //  Capture 100% of the transactions
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
};

export const enablePostHogAnalytics = (): void => {
    posthog.init('phc_3y02C4cuEDWvSdN1HfhBJ7x4eSOooPJVPirZh6azFNt', {
        api_host: 'https://eu.i.posthog.com',
        person_profiles: 'identified_only',
    });
};
